import NextHead from "next/head";
import React from "react";
import { useAppContext } from "../../../../lib/appContext";

export interface IProps {
  title: string;
  description: string;
  noIndex?: boolean;
}

const Head: React.FC<IProps> = ({ title, description, noIndex }) => {
  const { locale } = useAppContext();
  return (
    <NextHead>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:locale" content={locale.replace("-", "_")} />
      {Boolean(noIndex) && <meta name="robots" content="noindex, nofollow" />}
    </NextHead>
  );
};

export { Head };
